class EventDispatcher {
    constructor() {
        this.listeners = [];
    }

    invokeListeners(args, context) {
        for (let i = 0, x = this.listeners.length; i < x; i++) {
            this.invokeListener(this.listeners[i], args, context);
        }
    }

    invokeListener(listener, args, context) {
        if (typeof context === typeof undefined) {
            context = this;
        }

        listener.apply(context, args);
    }

    addListener(listener) {
        return new EventDispatcherSubscription(this, listener);
    }

    static noop() {
        return new NoopEventDispatcher;
    }
}

class EventDispatcherSubscription {
    constructor(eventDispatcher, reference) {
        this.eventDispatcher = eventDispatcher;
        this.reference = reference;
        this.disposed = false;

        if (this.eventDispatcher.listeners.indexOf(reference) === -1) {
            this.eventDispatcher.listeners.push(reference);
        }
    }

    dispose() {
        let index = this.eventDispatcher.listeners.indexOf(this.reference);

        this.disposed = true;

        if (index === -1) {
            return false;
        } else {
            this.eventDispatcher.listeners.splice(index, 1);
            return true;
        }
    }
}

class NoopEventDispatcher {
    invokeListeners() {
        //noop
    }
    
    addListener() {
        //noop
    }
}

export default EventDispatcher;